function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  id: "Website",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M4.00000191,12 C4.0041523,17 9.50000191,17 9.50000191,17 C9.50000191,17 15.0495035,17 15.0000019,12 C15.0000019,7.5 9.50000191,1 9.50000191,1 C9.50000191,1 3.99625461,7.4855992 4.00000191,12 Z",
  id: "Path-9",
  stroke: "var(--icon-color)",
  fill: "var(--icon-color)"
}), React.createElement("polygon", {
  id: "Path",
  fill: "var(--icon-color-secondary)",
  points: "11 14 8 14 8 13.6000004 8.77312525 13.3000002 8.77312525 7.69999981 8 7.4000001 8 7 11 7 11 7.4000001 10.2955791 7.69999981 10.2955791 13.3000002 11 13.6000004"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    version: 1.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/water1.1a86f952.svg";
export { SvgComponent as ReactComponent };